<template>
  <div class="stores">
    <v-head></v-head>
    <div class="stores_content clearfix">
      <div>
        <img src="../../../static/images/store_banner.jpg" alt="">
      </div>
    </div>
    <div id="city">
      <div class="import_city clearfix">
        <div class="import_city_prov">
          <span>省份</span>
          <select name="" class="prov"  v-model="provselect" >
            <option v-for="b in prov" :value="b.province_id"  >{{b.province}}</option>
          </select>
        </div>
        <div class="import_city_city">
          <span>城市</span>
          <select name="" class="city"  v-model="cityselect" >
            <option v-for="b in city" :value="b.city_id">{{b.city}}</option>
          </select>
        </div>
        <div class="import_city_search">
          <span @click="search"><img src="../../../static/images/store.jpg" alt=""></span>
          <input type="text" placeholder="请输入店铺名称" v-model="store_id">
        </div>
      </div>
    </div>
    <div class="store_s" v-if="openstore" v-for="b in store" @click="m">
      <h1><a v-link="{name:'maps', params: { name: b.name}}">{{b.name}}</a></h1>
      <p>{{b.address}}</p>
    </div>
    <div class="store_s" v-if="openonlystore">
      <h1><a v-link="{name:'maps', params: { name:onlystore.name}}">{{onlystore.name}}</a></h1>
      <p>{{onlystore.address}}</p>
    </div>
    <v-footer></v-footer>

  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
//  import '../../../static/js/jquery.cityselect';

  export default {
    data () {
      return {
          prov:[],
          provselect:"",
          city:[],
          cityselect:"",
          store:[],
          openstore:false,
          store_id:"",
          onlystore:{},
          openonlystore:false
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    methods :{
      search:function () {
        var _this = this;
        _this.openstore = false;
        $.ajax({
          type: "get",
          url: __formalUrl__ + "api/getStoreByStoreId/" + this.store_id,
          dataType: "json",
          success: function (data) {
            if (data) {
              _this.openonlystore = true;
              _this.onlystore = data;
              console.log(147258369,data);
            }
          },
        });
      }
    },
    watch:{
      "provselect":function (){
        var _this = this;
        $.ajax({
          type: "get",
          url: __formalUrl__ + "api/getCityByProvinceId/" + this.provselect,
          dataType: "json",
          success: function (data) {
            if (data) {
              console.log(456123,data);
              _this.city = data

            }
          },
        });
      },
      "cityselect":function(){
        var _this = this;
        $.ajax({
          type: "get",
          url: __formalUrl__ + "api/getStoreByCityId/" + this.cityselect ,
          dataType: "json",
          success: function (data) {
            if (data) {
              _this.openonlystore = false;
              _this.openstore = true;
              _this.store = data;
              console.log(987654,data);
            }
          },
        });
      }

    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getProvince",
        dataType: "json",
        success: function (data) {
          if (data) {
              _this.prov = data;

          }
        },
      });
    },
    created () {

    }
  }
</script>

<style>
  .stores{width: 9rem;margin: 0 auto;}
  .store_s a{color: black}
  .stores_content{width:9rem;margin: 0.5rem 0}
  .stores_content div:first-child{width:100%}
  .stores_content img{width: 100%}
  .store_s h1{font-size: 0.25rem}
  .import_city{font-size: 0.18rem}
  .import_city_prov{float: left;margin-right: 1rem}
  .import_city_prov span{border: 0.01rem solid #000000;width: 0.7rem;height: 0.7rem;display: block  ;text-align: center;line-height: 0.7rem}
  .import_city_prov select{border: 0.01rem solid #000000;width: 2rem;height: 0.6rem;display: block;text-align: center}
  .import_city_city{float: left;margin-right: 1rem}
  .import_city_city span{border: 0.01rem solid #000000;width: 0.7rem;height: 0.7rem;display: block  ;text-align: center;line-height: 0.7rem}
  .import_city_city select{border: 0.01rem solid #000000;width: 2rem;height: 0.6rem;display: block;text-align: center}
  .import_city_search{float: left}
  .import_city_search span{border: 0.01rem solid #000000;width: 0.7rem;height: 0.7rem;display: block  ;text-align: center;line-height: 0.7rem}
  .import_city_search input{border: 0.01rem solid #000000;width: 2rem;height: 0.6rem;display: block;text-align: center}
  .store_s{width: 4rem;height: 2rem;border: 0.01rem solid #000000;margin-top: 0.2rem}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .stores{width: 100% !important;margin: 0 auto;}
    .store_s a{color: black}
    .store_s{width: 100%;box-sizing: border-box}
    .store_s h1{font-size: 0.25rem}
    .stores_content{width:100%;margin-top: 0.5rem}
    .stores_content div:first-child{width:100%}
    .stores_content img{width: 100%}
    .import_city{font-size: 0.18rem}
    .import_city_prov{margin: 0.2rem auto;width: 95%;text-align: center;float: none;line-height: 0.6rem}
    .import_city_prov span{border: 0.01rem solid #000000;width: 25%;height: 0.6rem;display: inline-block  ;text-align: center;line-height: 0.6rem}
    .import_city_prov select{border: 0.01rem solid #000000;width: 70%;height: 0.6rem;display: inline-block;text-align: center}
    .import_city_city{margin: 0.2rem auto;width: 95%;text-align: center;float: none;line-height: 0.6rem}
    .import_city_city span{border: 0.01rem solid #000000;width: 25%;height: 0.6rem;display: inline-block  ;text-align: center;line-height: 0.6rem}
    .import_city_city select{border: 0.01rem solid #000000;width: 70%;height: 0.6rem;display: inline-block;text-align: center}
    .import_city_search{margin: 0.2rem auto;width: 95%;text-align: center;float: none;line-height: 0.6rem;height: 0.6rem}
    .import_city_search span{border: 0.01rem solid #000000;width: 25%;height: 0.6rem;display: inline-block  ;text-align: center;line-height: 0.6rem;vertical-align: middle}
    .import_city_search input{border: 0.01rem solid #000000;width: 70%;height: 0.6rem;display: inline-block;text-align: left;line-height: 0.6rem;vertical-align: middle}
  }
</style>



// WEBPACK FOOTER //
// stores.vue?767c0fda